import { ReactElement } from 'react';
import { errorNotificationBuilder, NotificationTypes, useNotification } from '@css-xp/base';

export const usePlaceOrderNotification = () => {
  const { setNotificationSent, sendErrorNotification } = useNotification();
  return {
    notifyFailure: (message: string) => {
      sendErrorNotification(
        errorNotificationBuilder()
          .withId('ppc-place-order-failure')
          .withHeader(`We weren't able to place the order.`)
          .withMessage(message)
          .withDismissAfter(10000)
          .isVersion(NotificationTypes.FLAG)
          .build()
      );
      setNotificationSent(true);
    },
  };
};

export enum CheckoutOperation {
  CalculateEstimate,
  CalculateFreePlansEstimate,
  CheckoutOrContinue,
  SelectSoldToAddress,
  SelectPreferredPaymentMethod,
  ProvideUserConsent,
  PlaceOrder,
  Others,
  LinkAppToParentProduct,
  MaxUsersForFamilyContainer,
  PromocodeValidation,
}

const checkOutOperationToErrorNotificationHeaderMapping = {
  [CheckoutOperation.CalculateEstimate]: "We can't show these details right now",
  [CheckoutOperation.CalculateFreePlansEstimate]: "We can't show these details right now",
  [CheckoutOperation.CheckoutOrContinue]: 'We could not continue, something went wrong.',
  [CheckoutOperation.SelectSoldToAddress]: 'Select sold-to address operation failed.',
  [CheckoutOperation.SelectPreferredPaymentMethod]: 'Select payment method operation failed',
  [CheckoutOperation.ProvideUserConsent]: 'We could not capture your consent for this order.',
  [CheckoutOperation.PlaceOrder]: `We weren't able to place the order.`,
  [CheckoutOperation.Others]: 'Apologies, something went wrong at our end.',
  [CheckoutOperation.LinkAppToParentProduct]: 'We could not link the product to app.',
  [CheckoutOperation.MaxUsersForFamilyContainer]:
    'We couldn’t fetch all the required details for the selected entitlement.',
  [CheckoutOperation.PromocodeValidation]: 'We could not validate the promocode.',
};

export const usePartnerCheckoutNotification = () => {
  const { setNotificationSent, sendErrorNotification } = useNotification();
  return {
    notifyFailure: (message: string | ReactElement, checkoutOperation: CheckoutOperation) => {
      sendErrorNotification(
        errorNotificationBuilder()
          .withId(`${checkoutOperation.toString()}-ppc-place-order-failure`)
          .withHeader(checkOutOperationToErrorNotificationHeaderMapping[checkoutOperation])
          .withMessage(message)
          .withDismissAfter(10000)
          .isVersion(NotificationTypes.FLAG)
          .build()
      );
      setNotificationSent(true);
    },
  };
};
